import React, { useCallback } from 'react'

import { Button, Check, Icon, Modal } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, number, string } from 'prop-types'

import I18n from 'Pods/Shared/I18n'

function formatCurrency(amount) {
  return `$${amount.toFixed(2)}`
}

// UTC, not the browser zone -- see the matching note in CancelSubscriptionModal/useCancelModal.js.
function formatAccessDate(isoDate, locale = 'en') {
  return new Date(isoDate).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC',
  })
}

function CancelConfirmationModal({
  isOpen,
  onDone,
  accessUntil = null,
  cancelFee = 0,
  locale = 'en',
}) {
  const translate = useCallback(
    (key, options = {}) => I18n.t(
      `subscription_management.cancel_modal.confirmation.${key}`,
      { ns: 'rails', lng: locale, ...options }
    ),
    [locale]
  )

  const dateFormatted = accessUntil ? formatAccessDate(accessUntil, locale) : null

  let description
  if (cancelFee > 0 && dateFormatted) {
    description = translate('body_fee', {
      date: dateFormatted,
      fee: formatCurrency(cancelFee),
    })
  } else if (dateFormatted) {
    description = translate('body_no_fee', { date: dateFormatted })
  } else {
    description = translate('body_no_fee_no_date')
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onDone}
      header={translate('header')}
      width="small"
      canClose
      customClass="cancel-confirmation-modal"
    >
      <div className="cancel-confirmation-modal__body">
        <div className="cancel-confirmation-modal__icon">
          <Icon svgComponent={Check} size="large" color="dark" />
        </div>
        <h4 className="cancel-confirmation-modal__title">{translate('title')}</h4>
        <p className="cgt-text-medium cancel-confirmation-modal__description">{description}</p>
        <Button
          type="primary"
          actionType="button"
          onClick={onDone}
          customClass="cancel-confirmation-modal__done"
        >
          {translate('done_button')}
        </Button>
      </div>
    </Modal>
  )
}

CancelConfirmationModal.propTypes = {
  isOpen: bool.isRequired,
  onDone: func.isRequired,
  accessUntil: string,
  cancelFee: number,
  locale: string,
}

export default CancelConfirmationModal
